import approved from './approvedNavigation.json';

/** Stable identities are shared by the menu, screen contracts and documentation. */
export interface NavigationNode {
  readonly id: string;
  readonly label: string;
  readonly description?: string;
  readonly children: readonly NavigationNode[];
}

export const approvedNavigation: readonly NavigationNode[] = approved;

export interface NavigationEntry {
  readonly node: NavigationNode;
  readonly ancestors: readonly NavigationNode[];
  readonly depth: number;
}

export function flattenNavigation(nodes: readonly NavigationNode[] = approvedNavigation): NavigationEntry[] {
  const result: NavigationEntry[] = [];
  const seen = new Set<string>();
  function visit(items: readonly NavigationNode[], ancestors: readonly NavigationNode[]): void {
    for (const node of items) {
      if (!node.id || !node.label.trim() || seen.has(node.id)) {
        throw new Error(`Invalid or duplicate navigation identity: ${node.id}`);
      }
      if (ancestors.length >= 3) throw new Error(`Navigation exceeds three levels: ${node.id}`);
      seen.add(node.id);
      result.push({ node, ancestors, depth: ancestors.length + 1 });
      visit(node.children, [...ancestors, node]);
    }
  }
  visit(nodes, []);
  return result;
}

export const navigationIndex = new Map(flattenNavigation().map(entry => [entry.node.id, entry]));

/** Record-detail URLs are content, never another permanent menu level. */
export function navigationTrail(id: string): readonly NavigationNode[] {
  const entry = navigationIndex.get(id);
  return entry ? [...entry.ancestors, entry.node] : [];
}
